'use strict';

import ngResource from 'angular-resource';

function MonthlyActivePowerService ($resource) {
    return $resource(
        '/api/monthly_active_power/:id', { id: '@id' },
        { 
            show : { method: 'GET', isArray: false }
        }
    )
}

export default angular.module('leptonApp.MonthlyActivePowerService', ['ngResource'])
    .factory('MonthlyActivePowerService', ['$resource', MonthlyActivePowerService])
    .name;



// WEBPACK FOOTER //
// ./public/dev/components/api/monthly_active_power/monthly_active_power.service.js